export default [
    
    {
        value: "RelatorioMensal",
        text: "-",
    },
    {
        value: "RelatorioParcial",
        text: "Relatório parcial",
    },
    {
        value: "RelatorioFinal",
        text: "-"
    },
    {
        value: "BoletimMedicao",
        text: "Boletim medição"
    },
]